export default () => 'UUID'
